var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"newsTitle"},[_c('div',{staticClass:"title"},[_vm._m(0),_c('div',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"backImg"},[_c('img',{staticClass:"imgClass",attrs:{"src":require("../assets/titleback.png")}})])
}]

export { render, staticRenderFns }